module.exports = __webpack_public_path__ + "static/media/thumb.477c6de9.jpg";